import type { Area } from 'react-easy-crop'

const loadImage = (src: string): Promise<HTMLImageElement> => new Promise((resolve, reject) => {
    const image = new Image()

    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', reject)
    image.src = src
})

/**
 * Renders the cropped area of an image (as returned by react-easy-crop's `onCropComplete`) onto a
 * square canvas of `size` pixels and exports it as a JPEG.
 */
export const cropImage = async (src: string, area: Area, size = 512, quality = 0.9): Promise<Blob> => {
    const image = await loadImage(src)
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    if (! context) {
        throw new Error('Canvas 2D context is not available')
    }

    canvas.width = size
    canvas.height = size

    context.drawImage(image, area.x, area.y, area.width, area.height, 0, 0, size, size)

    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error('Could not export cropped image'))), 'image/jpeg', quality)
    })
}
